import { combineReducers } from 'redux';

import loadFiscalNumberError from './loadFiscalNumberError';
import editCorporationFiscalNumberError from './editCorporationFiscalNumberError';
import editIndividualFiscalNumberError from './editIndividualFiscalNumberError';

export default combineReducers({
  loadFiscalNumberError,
  editCorporationFiscalNumberError,
  editIndividualFiscalNumberError,
});
